module.exports = __webpack_public_path__ + "static/img/yshh1-3-1.5344850.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/yshh1-3-1.png
// module id = 779
// module chunks = 0